// components/Header.tsx
import HeaderIconSearch from '@pancakeswap/uikit/components/Svg/Icons/HeaderIconSearch'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  padding: 0px 16px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 600px;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(24px);
  cursor: pointer;
`

const Search = ({ onClick }: { onClick: () => void }) => {
  return (
    <Wrapper onClick={onClick}>
      <HeaderIconSearch />
    </Wrapper>
  )
}

export default Search
